import { memo } from 'react'
import { Skeleton } from '../Skeleton'

interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  // Shows a pulsing placeholder in the checkbox's shape while its value loads
  skeleton?: boolean
}

export const Checkbox = memo(({ id, name, className, skeleton, ...rest }: CheckboxProps) => {
  if (skeleton) {
    return <Skeleton shape="checkbox" />
  }
  const classes = ['checkbox-control', className ?? ''].filter(Boolean).join(' ')
  return <input type="checkbox" id={id} name={name} className={classes} {...rest} />
})

Checkbox.displayName = 'Checkbox'
